// extracted by mini-css-extract-plugin
export default {"mask":"homeNew_mask__vxsV8"};